/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateEntityBody,
  Entity,
  Error,
  GetEntities200,
  GetEntitiesParams,
  PatchEntityBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Create a new legal entity (business, organization, or sole proprietor). Entities are the core organizational unit that owns customers, invoices, and items. Each entity can have custom number formatting for invoices and other settings.
 * @summary Create a new entity
 */
export type createEntityResponse201 = {
  data: Entity
  status: 201
}

export type createEntityResponse400 = {
  data: Error
  status: 400
}

export type createEntityResponse401 = {
  data: Error
  status: 401
}

export type createEntityResponse403 = {
  data: Error
  status: 403
}

export type createEntityResponse404 = {
  data: Error
  status: 404
}

export type createEntityResponse422 = {
  data: ValidationError
  status: 422
}

export type createEntityResponse500 = {
  data: Error
  status: 500
}

export type createEntityResponseSuccess = (createEntityResponse201) & {
  headers: Headers;
};
export type createEntityResponseError = (createEntityResponse400 | createEntityResponse401 | createEntityResponse403 | createEntityResponse404 | createEntityResponse422 | createEntityResponse500) & {
  headers: Headers;
};

export type createEntityResponse = (createEntityResponseSuccess | createEntityResponseError)

export const getCreateEntityUrl = () => {


  

  return `/entities`
}

export const createEntity = async (createEntityBody: CreateEntityBody, options?: RequestInit): Promise<createEntityResponse> => {
  
  return customFetch<createEntityResponse>(getCreateEntityUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEntityBody,)
  }
);}
  

/**
 * Retrieve a paginated list of entities with optional filtering and sorting. Supports cursor-based pagination for efficient navigation, flexible JSON querying with MongoDB-style operators, full-text search across entity names and countries, and sorting by various entity properties.
 * @summary List all entities
 */
export type getEntitiesResponse200 = {
  data: GetEntities200
  status: 200
}

export type getEntitiesResponse400 = {
  data: Error
  status: 400
}

export type getEntitiesResponse401 = {
  data: Error
  status: 401
}

export type getEntitiesResponse403 = {
  data: Error
  status: 403
}

export type getEntitiesResponse404 = {
  data: Error
  status: 404
}

export type getEntitiesResponse500 = {
  data: Error
  status: 500
}

export type getEntitiesResponseSuccess = (getEntitiesResponse200) & {
  headers: Headers;
};
export type getEntitiesResponseError = (getEntitiesResponse400 | getEntitiesResponse401 | getEntitiesResponse403 | getEntitiesResponse404 | getEntitiesResponse500) & {
  headers: Headers;
};

export type getEntitiesResponse = (getEntitiesResponseSuccess | getEntitiesResponseError)

export const getGetEntitiesUrl = (params?: GetEntitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/entities?${stringifiedParams}` : `/entities`
}

export const getEntities = async (params?: GetEntitiesParams, options?: RequestInit): Promise<getEntitiesResponse> => {
  
  return customFetch<getEntitiesResponse>(getGetEntitiesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a single legal entity by its unique identifier. Returns the full entity including settings, metadata, and computed country rules.
 * @summary Get entity by ID
 */
export type getEntityByIdResponse200 = {
  data: Entity
  status: 200
}

export type getEntityByIdResponse401 = {
  data: Error
  status: 401
}

export type getEntityByIdResponse403 = {
  data: Error
  status: 403
}

export type getEntityByIdResponse404 = {
  data: Error
  status: 404
}

export type getEntityByIdResponse500 = {
  data: Error
  status: 500
}

export type getEntityByIdResponseSuccess = (getEntityByIdResponse200) & {
  headers: Headers;
};
export type getEntityByIdResponseError = (getEntityByIdResponse401 | getEntityByIdResponse403 | getEntityByIdResponse404 | getEntityByIdResponse500) & {
  headers: Headers;
};

export type getEntityByIdResponse = (getEntityByIdResponseSuccess | getEntityByIdResponseError)

export const getGetEntityByIdUrl = (id: string,) => {


  

  return `/entities/${id}`
}

export const getEntityById = async (id: string, options?: RequestInit): Promise<getEntityByIdResponse> => {
  
  return customFetch<getEntityByIdResponse>(getGetEntityByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing entity's details. All fields are optional; only provided fields will be updated. Use this to modify entity information, address, tax details, or custom settings. Note: Country and country_code cannot be changed after entity creation.
 * @summary Update an entity
 */
export type patchEntityResponse200 = {
  data: Entity
  status: 200
}

export type patchEntityResponse400 = {
  data: Error
  status: 400
}

export type patchEntityResponse401 = {
  data: Error
  status: 401
}

export type patchEntityResponse403 = {
  data: Error
  status: 403
}

export type patchEntityResponse404 = {
  data: Error
  status: 404
}

export type patchEntityResponse422 = {
  data: ValidationError
  status: 422
}

export type patchEntityResponse500 = {
  data: Error
  status: 500
}

export type patchEntityResponseSuccess = (patchEntityResponse200) & {
  headers: Headers;
};
export type patchEntityResponseError = (patchEntityResponse400 | patchEntityResponse401 | patchEntityResponse403 | patchEntityResponse404 | patchEntityResponse422 | patchEntityResponse500) & {
  headers: Headers;
};

export type patchEntityResponse = (patchEntityResponseSuccess | patchEntityResponseError)

export const getPatchEntityUrl = (id: string,) => {


  

  return `/entities/${id}`
}

export const patchEntity = async (id: string,
    patchEntityBody: PatchEntityBody, options?: RequestInit): Promise<patchEntityResponse> => {
  
  return customFetch<patchEntityResponse>(getPatchEntityUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchEntityBody,)
  }
);}
  

/**
 * Re-enable a disabled entity. Enabled entities can create documents (invoices, estimates, credit notes, etc.). This operation is idempotent - enabling an already enabled entity has no effect.
 * @summary Enable an entity
 */
export type enableEntityResponse200 = {
  data: Entity
  status: 200
}

export type enableEntityResponse400 = {
  data: Error
  status: 400
}

export type enableEntityResponse401 = {
  data: Error
  status: 401
}

export type enableEntityResponse403 = {
  data: Error
  status: 403
}

export type enableEntityResponse404 = {
  data: Error
  status: 404
}

export type enableEntityResponse422 = {
  data: ValidationError
  status: 422
}

export type enableEntityResponse500 = {
  data: Error
  status: 500
}

export type enableEntityResponseSuccess = (enableEntityResponse200) & {
  headers: Headers;
};
export type enableEntityResponseError = (enableEntityResponse400 | enableEntityResponse401 | enableEntityResponse403 | enableEntityResponse404 | enableEntityResponse422 | enableEntityResponse500) & {
  headers: Headers;
};

export type enableEntityResponse = (enableEntityResponseSuccess | enableEntityResponseError)

export const getEnableEntityUrl = (id: string,) => {


  

  return `/entities/${id}/enable`
}

export const enableEntity = async (id: string, options?: RequestInit): Promise<enableEntityResponse> => {
  
  return customFetch<enableEntityResponse>(getEnableEntityUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Disable an entity. Disabled entities cannot create documents (invoices, estimates, credit notes, etc.) but all data remains accessible and settings can still be updated. This operation is idempotent - disabling an already disabled entity has no effect.
 * @summary Disable an entity
 */
export type disableEntityResponse200 = {
  data: Entity
  status: 200
}

export type disableEntityResponse400 = {
  data: Error
  status: 400
}

export type disableEntityResponse401 = {
  data: Error
  status: 401
}

export type disableEntityResponse403 = {
  data: Error
  status: 403
}

export type disableEntityResponse404 = {
  data: Error
  status: 404
}

export type disableEntityResponse422 = {
  data: ValidationError
  status: 422
}

export type disableEntityResponse500 = {
  data: Error
  status: 500
}

export type disableEntityResponseSuccess = (disableEntityResponse200) & {
  headers: Headers;
};
export type disableEntityResponseError = (disableEntityResponse400 | disableEntityResponse401 | disableEntityResponse403 | disableEntityResponse404 | disableEntityResponse422 | disableEntityResponse500) & {
  headers: Headers;
};

export type disableEntityResponse = (disableEntityResponseSuccess | disableEntityResponseError)

export const getDisableEntityUrl = (id: string,) => {


  

  return `/entities/${id}/disable`
}

export const disableEntity = async (id: string, options?: RequestInit): Promise<disableEntityResponse> => {
  
  return customFetch<disableEntityResponse>(getDisableEntityUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

